import type { ITicketPersonalLoanFees } from './TicketPersonalLoanFees.interface';

export default class TicketPersonalLoanFees implements ITicketPersonalLoanFees {
  brokeragePercent: number;
  brokerageAmount: number;
  lenderApplicationFee: number;

  static build = (data: ITicketPersonalLoanFees) => new TicketPersonalLoanFees(data);
  static blank = () => new TicketPersonalLoanFees();

  /**
   * Constructor
   * @param {ITicketPersonalLoanFees} data
   */
  constructor(data?: ITicketPersonalLoanFees) {
    this.brokeragePercent = parseFloat(data?.brokeragePercent || 0);
    this.brokerageAmount = parseFloat(data?.brokerageAmount || 0);
    this.lenderApplicationFee = parseFloat(data?.lenderApplicationFee || 0);
  }
}
